import { useReducer } from 'react';

var toggleReducer = function toggleReducer(state, nextValue) {
  return typeof nextValue === 'boolean' ? nextValue : !state;
};

var useToggle = function useToggle(initialValue) {
  return useReducer(toggleReducer, initialValue);
};

export default useToggle;